import React, { useState } from "react";
import ModalBasic from "./ModalBasic";
import { PrimaryButton } from "./Buttons.jsx";

const DuplicateBroadcastModal = ({
  isOpen,
  onClose,
  onConfirm,
  originalName,
  isLoading = false,
}) => {
  const [duplicateName, setDuplicateName] = useState("");

  // Generate default name when modal opens
  React.useEffect(() => {
    if (isOpen && originalName) {
      setDuplicateName(`${originalName} (Copy)`);
    }
  }, [isOpen, originalName]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (duplicateName.trim()) {
      onConfirm(duplicateName.trim());
    }
  };

  const handleClose = () => {
    setDuplicateName("");
    onClose();
  };

  return (
    <ModalBasic
      id="duplicate-broadcast-modal"
      title="Duplicate Broadcast"
      modalOpen={isOpen}
      setModalOpen={handleClose}
      width="md"
    >
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div>
            <label
              htmlFor="duplicate-name"
              className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2"
            >
              New Broadcast Name
            </label>
            <input
              id="duplicate-name"
              type="text"
              value={duplicateName}
              onChange={(e) => setDuplicateName(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-slate-700 dark:text-slate-100"
              placeholder="Enter broadcast name..."
              required
              disabled={isLoading}
              autoFocus
            />
          </div>
          
          <div className="text-sm text-slate-600 dark:text-slate-400">
            This will create a copy of "{originalName}" with all the same content and settings as a draft.
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            onClick={handleClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md hover:bg-slate-50 dark:hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
          >
            Cancel
          </button>
          <PrimaryButton
            type="submit"
            disabled={!duplicateName.trim() || isLoading}
          >
            {isLoading ? "Duplicating..." : "Duplicate Broadcast"}
          </PrimaryButton>
        </div>
      </form>
    </ModalBasic>
  );
};

export default DuplicateBroadcastModal;
